module.exports = __webpack_public_path__ + "img/gum.2284e60e.svg";